export default __webpack_public_path__ + "static/media/exam-beep.a48eb370.md";